import type { ReactElement } from 'react';
import { map } from 'rxjs/operators';
import { connect } from '@ardoq/rxbeach';
import { Features, featureOperations } from '@ardoq/features';
import { ToastStack } from '@ardoq/status-ui';
import type { I18nLocale } from '@ardoq/i18n';
import { featureContext$ } from 'streams/featureContext$';

const EMPTY_LOCALE: I18nLocale = {};

type PptxExportToastsProps = {
  isEnabled: boolean;
};

const PptxExportToastsContent = ({
  isEnabled,
}: PptxExportToastsProps): ReactElement | null =>
  isEnabled ? <ToastStack i18nLocale={EMPTY_LOCALE} /> : null;

export const PptxExportToasts = connect(
  PptxExportToastsContent,
  featureContext$.pipe(
    map(featureContext => ({
      isEnabled: featureOperations.hasFeature(
        featureContext,
        Features.PRESENTATIONS_PPTX_EXPORT
      ),
    }))
  )
);
